import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { StyledCrmEnrichmentWizardButtonsWrapper } from "./styles";

type Props = {
    isNextDisabled: boolean;
    isLoading: boolean;
    activePageIndex: number;
    numberOfPages: number;
    onBackStepClick: VoidFunction;
    onNextStepClick: VoidFunction;
};

const CrmEnrichmentWizardNavButtons = ({
    onBackStepClick,
    isNextDisabled,
    isLoading,
    onNextStepClick,
    activePageIndex,
    numberOfPages,
}: Props) => {
    const isFirstStep = activePageIndex === 0;
    const isLastStep = numberOfPages - 1 === activePageIndex;

    return (
        <StyledCrmEnrichmentWizardButtonsWrapper>
            <Button
                onClick={onBackStepClick}
                type="flat"
            >
                {translate(isFirstStep ? "si.common.button.cancel" : "si.common.button.back")}
            </Button>

            <Button
                onClick={onNextStepClick}
                isDisabled={isNextDisabled}
                isLoading={isLoading}
            >
                {translate(isLastStep ? "common.submit" : "common.next")}
            </Button>
        </StyledCrmEnrichmentWizardButtonsWrapper>
    );
};

export default CrmEnrichmentWizardNavButtons;
